import { render, staticRenderFns } from "./FBModeredit.vue?vue&type=template&id=b4ecdc52&scoped=true&"
import script from "./FBModeredit.vue?vue&type=script&lang=js&"
export * from "./FBModeredit.vue?vue&type=script&lang=js&"
import style0 from "./FBModeredit.vue?vue&type=style&index=0&id=b4ecdc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ecdc52",
  null
  
)

export default component.exports